export default {
  getStockItemLink: (state) => state.stockItemLink,
};
